import { Component, inject } from '@angular/core';
import {NgStyle} from "@angular/common";
import { DataService } from 'src/app/service/data.service';


@Component({
    selector: 'project-count',
    imports: [
        NgStyle
    ],
    templateUrl: './project-count.component.html'
})

export class ProjectCountComponent {
    protected dataService = inject(DataService);


    public projectCount;

    ngOnInit() {

        this.fillProjectCountVar();

    }

    private async fillProjectCountVar() {

        this.projectCount = await this.dataService.getProjectCount();

    }

}
